module.exports = __webpack_public_path__ + "2a872e2650970e5a5331172fd1e245e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/pricing/alipayPay.png
// module id = 448
// module chunks = 0